import { Directive, HostListener } from "@angular/core";

@Directive({
	selector: "[click-stop-propagation]"
})
export class ClickStopPropagation {
	@HostListener("click", ["$event"])
	public onClick(e: any): void {
		e.stopPropagation();
		e.preventDefault();
	}
}